export const navbar = {
  Search: 'Buscar',
  SearchPlaceholder: '¿Qué quieres reproducir?',
  Home: 'Inicio',
  'Your Library': 'Tu Biblioteca',
  'Collapse your library': 'Colapsar tu biblioteca',
  'Expand your library': 'Expandir tu biblioteca',
  Language: 'Idioma',
  'Contact me': 'Contáctame',
  'Choose a language': 'Elige un idioma',
};
